import Swiper from "swiper";

window.addEventListener("load", function () {
  window.swiperProjects = new Swiper(".projects__slider", {
    // spaceBetween: 32,
    speed: 1500,
    slidesPerView: 3,
    freeMode: true,
    // slidesOffsetBefore: 30,
    // slidesOffsetAfter: 50,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".projects__wrap-slider-button_next",
      prevEl: ".projects__wrap-slider-button_prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1150: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
  });

  if (window.swiperProjects) {
    jQuery(".projects__wrap-slider-button_next").on("click", () =>
      window.swiperProjects.slideNext()
    );
    jQuery(".projects__wrap-slider-button_prev").on("click", () =>
      window.swiperProjects.slidePrev()
    );
  }
});
